import { isFailure } from "@sportal/api";
import _ from "lodash";

import { fetchReport, mergeData } from "../../reports.actions";
import {
  BarChartActionTypes,
  FormattedBarChartStoreSlice,
  LOAD_BARCHART,
  LOAD_BARCHART_FAILURE,
  LOAD_BARCHART_SUCCESS,
} from "./barchart.types";
import { SBThunkAction } from "../../../redux.types";
import {
  DataKeys,
  ReportsPeriod,
} from "../../../../helpers/reports.helper.types";

export const loadBarChartReport =
  (
    endpoints: DataKeys[],
    options: {
      period: ReportsPeriod;
      profile: string;
    }
  ): SBThunkAction<void, BarChartActionTypes> =>
  (dispatch) => {
    dispatch(
      async () => {
        const { period, profile } = options;
        const config = {
          period,
          ...(profile !== "all_profiles" && { profile }),
        };

        dispatch(loadBarChart({ period, profile }));

        Promise.all(
          endpoints.map(
            async (endpoint) =>
              await dispatch(fetchReport(endpoint, config, "get"), {
                showLoader: false,
              })
          )
        ).then((results) => {
          const failure = results.find(isFailure);

          if (failure) {
            dispatch(
              loadBarChartFailure({
                error: failure.error,
                period,
                profile,
              })
            );
            return;
          }

          const result = _.zipObject(
            endpoints,
            _.values(_.mapValues(results, "data"))
          );

          dispatch(
            loadBarChartSuccess({
              data: mergeData(result),
              period,
              profile,
            })
          );
        });
      },
      { showLoader: false }
    );
  };

const loadBarChart = ({ period, profile }): BarChartActionTypes => ({
  type: LOAD_BARCHART,
  payload: {
    period,
    profile,
  },
});

const loadBarChartSuccess = ({
  data,
  period,
  profile,
}: {
  data: FormattedBarChartStoreSlice[];
  period: ReportsPeriod;
  profile: string;
}): BarChartActionTypes => ({
  type: LOAD_BARCHART_SUCCESS,
  payload: {
    data,
    period,
    profile,
  },
});

const loadBarChartFailure = ({
  error,
  period,
  profile,
}): BarChartActionTypes => ({
  type: LOAD_BARCHART_FAILURE,
  payload: {
    error,
    period,
    profile,
  },
});
